import React from "react";

const TitlePage = ({ title }) => {
    return <h1 className="title-page">{title}</h1>;
};

export default TitlePage;
